import React from 'react'
import { observer } from 'mobx-react'
import Loader from '../../components/Loader'
import GlobalBlocklist from './GlobalBlocklist'
import GlobalBlocklistStore from '../../stores/global-blocklist'

@observer
class _GlobalBlocklist extends React.Component {
  state = {
    addDialogOpen: false
  }

  constructor(props) {
    super(props)
    this.store = new GlobalBlocklistStore()
  }

  onOpenAdd = () => this.setState({ addDialogOpen: true })
  onCloseAdd = () => this.setState({ addDialogOpen: false })

  onSave = async (domains) => {
    return await this.store.add(domains)
  }

  onRemove = async (id) => {
    return await this.store.remove(id)
  }

  onChangePage = (e, page) => this.store.onChangePage(page)

  onChangeRowsPerPage = ({ target: { value } }) =>
    this.store.onChangeRowsPerPage(value)

  onChangeFilters = (name) => (object) => {
    let value = null
    if (object.hasOwnProperty('target')) {
      value = object.target.value
    } else {
      value = object
    }
    this.store.onChangeFilter('domain', value)
  }

  render() {
    const {
      listProps,
      thinking,
    } = this.store

    if (listProps.initialization) {
      return <Loader />
    }

    return (
      <GlobalBlocklist
        {...listProps}
        thinking={thinking}
        onChangeSort={this.onChangeSort}
        onChangePage={this.onChangePage}
        onChangeFilters={this.onChangeFilters}
        onChangeRowsPerPage={this.onChangeRowsPerPage}
        addDialogOpen={this.state.addDialogOpen}
        onOpenAdd={this.onOpenAdd}
        onCloseAdd={this.onCloseAdd}
        onSave={this.onSave}
        onRemove={this.onRemove}
      />
    )
  }
}

export default _GlobalBlocklist
